/* recovered from production bundle — lib/http */
// @ts-nocheck

import { getToken, clearToken, apiPath } from './auth';

export async function fetchJson(e, t = {}) {
  const n = getToken();
  const r = {
    ...t.headers
  };
  if (n) {
    r.Authorization = `Bearer ${n}`;
  }
  if (t.body && !(t.body instanceof FormData)) {
    r["Content-Type"] = "application/json";
  }
  const s = await fetch(apiPath(e), {
    ...t,
    headers: r
  });
  if (s.status === 401) {
    if (n) {
      clearToken();
      window.location.reload();
    }
    throw new Error("Unauthorized");
  }
  if (!s.ok) {
    const a = await s.json().catch(() => ({
      error: s.statusText
    }));
    const generic = /^(internal server error|error)$/i.test(String(a.error ?? "").trim());
    const detail = typeof a.message === "string" ? a.message.trim() : "";
    let msg = a.error ?? a.message ?? s.statusText;
    if (generic && detail) {
      if (/unique constraint failed/i.test(detail)) {
        msg = "A connection with this name already exists";
      } else {
        const line = detail.split("\n").map((l: string) => l.trim()).find((l: string) => l.length > 0);
        msg = line ?? detail;
      }
    }
    throw new Error(msg);
  }
  if ((s.headers.get("content-type") ?? "").includes("application/json")) {
    return s.json();
  } else {
    return s.text();
  }
}
export async function download(e, t) {
  const n = getToken();
  const r = await fetch(apiPath(e), {
    headers: n ? {
      Authorization: `Bearer ${n}`
    } : {}
  });
  if (r.status === 401) {
    if (n) {
      clearToken();
      window.location.reload();
    }
    throw new Error("Unauthorized");
  }
  if (!r.ok) {
    const c = await r.json().catch(() => ({
      error: r.statusText
    }));
    throw new Error(c.error ?? c.message ?? r.statusText);
  }
  const s = r.headers.get("content-disposition") ?? "";
  const i = /filename="?([^";\n]+)"?/.exec(s);
  const a = (i == null ? undefined : i[1]) ?? t;
  const l = await r.blob();
  const E = URL.createObjectURL(l);
  const u = document.createElement("a");
  u.href = E;
  u.download = a;
  u.click();
  URL.revokeObjectURL(E);
}
export function streamGet(e, n, t = {}) {
  const r = getToken();
  const controller = t.signal ? null : new AbortController();
  const signal = t.signal ?? controller?.signal;
  const run = () => fetch(apiPath(e), {
    ...t,
    signal,
    headers: {
      ...(r ? { Authorization: `Bearer ${r}` } : {}),
      ...t.headers,
    },
  }).then(async (s) => {
    if (s.status === 401) {
      if (r) {
        clearToken();
        window.location.reload();
      }
      throw new Error('Unauthorized');
    }
    if (!s.ok) {
      throw new Error(`HTTP ${s.status}`);
    }
    const i = s.body?.getReader();
    if (!i) return;
    const a = new TextDecoder();
    let l = '';
    while (true) {
      const { done: E, value: u } = await i.read();
      if (E) break;
      l += a.decode(u, { stream: true });
      const c = l.split('\n');
      l = c.pop() ?? '';
      for (const T of c) {
        if (T.startsWith('data: ')) {
          try {
            n(JSON.parse(T.slice(6)));
          } catch {}
        }
      }
    }
  });
  return { promise: run(), abort: () => controller?.abort() };
}

export function streamPost(e, t = {}, n) {
  const r = getToken();
  return fetch(apiPath(e), {
    ...t,
    headers: {
      "Content-Type": "application/json",
      ...(r ? {
        Authorization: `Bearer ${r}`
      } : {}),
      ...t.headers
    }
  }).then(async s => {
    if (!s.ok) {
      throw new Error(`HTTP ${s.status}`);
    }
    const i = s.body.getReader();
    const a = new TextDecoder();
    let l = "";
    while (true) {
      const {
        done: E,
        value: u
      } = await i.read();
      if (E) {
        break;
      }
      l += a.decode(u, {
        stream: true
      });
      const c = l.split(`
`);
      l = c.pop() ?? "";
      for (const T of c) {
        if (T.startsWith("data: ")) {
          try {
            n(JSON.parse(T.slice(6)));
          } catch {}
        }
      }
    }
  });
}
